<script setup lang="ts">
import { SearchSmIcon, XCloseIcon } from '@gohighlevel/ghl-icons/24/outline'
import { onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { onSearchSubmit } from '../searchHelper'

const { t } = useI18n()
const search = ref('')
const router = useRouter()

const handleSubmit = e => {
  e.preventDefault()
  onSearchSubmit(router, search.value)
}

const handleClear = () => {
  search.value = ''
}

onMounted(() => {
  if (
    router.currentRoute.value.query.q &&
    ['channel-search', 'group-home-search'].includes(
      router.currentRoute.value.name as string
    )
  ) {
    search.value = router.currentRoute.value.query.q as string
  }
})
watch(
  () => router.currentRoute.value.name,
  () => {
    if (
      [
        'channel-search',
        'group-home-search',
        'group-search-post-view',
        'channel-search-post-view',
      ].includes(router.currentRoute.value.name as string)
    ) {
      search.value = router.currentRoute.value.query.q as string
    } else {
      search.value = ''
    }
  }
)
</script>
<template>
  <div
    class="flex h-10 w-[496px] items-center rounded-[34px] border-[0.4px] border-solid border-communities-border bg-communities-sidebar-background-secondary px-4 py-1"
  >
    <SearchSmIcon class="h-5 w-5 text-communities-sidebar-font-primary" />
    <form class="ml-1 w-[calc(100%-40px)]" @submit="handleSubmit">
      <input
        id="search-input"
        v-model="search"
        type="text"
        :placeholder="t('common.search')"
        class="h-6 w-full border-none bg-communities-sidebar-background-secondary text-base text-communities-sidebar-font-primary outline-none placeholder:text-left placeholder:text-base placeholder:text-communities-font-secondary"
      />
    </form>

    <XCloseIcon
      v-if="search"
      class="h-5 w-5 cursor-pointer"
      @click="handleClear"
    />
  </div>
</template>
<style scoped></style>
